import apiMeterClient from './apiMeterClient'

const END_POINT = '/sensors'

const last = (meter) => apiMeterClient.get(`${END_POINT}/status/${meter.id}?key=${meter.key}`)

const Sensors = { last }

export default Sensors